import React from 'react'
import PropTypes from 'prop-types'
import CheckBox from '../UserAccount/RegisterFormCheckBox'
import './index.css'

export class Agreement extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      open: false
    }
    this.handleClick = this.handleClick.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  handleClick () {
    this.setState(prevState => ({
      open: !prevState.open
    }))
  }

  handleSubmit (submit) {
    this.setState({
      open: false
    })
    this.props.onChange({value: submit})
  }

  render () {
    return (
      <React.Fragment>
        <CheckBox value={this.props.agreement} ok onChange={this.props.onChange}
          label={<span className='asa' onClick={this.handleClick}>
            Souhlas se zasíláním novinek</span>}/>
        {this.state.open
          ? <InfoForm onClick={this.handleSubmit} />
          : null
        }
      </React.Fragment>
    )
  }
}

Agreement.propTypes = {
  agreement: PropTypes.bool,
  onChange: PropTypes.func
}

export default Agreement

const InfoForm = ({onClick}) => (
  <div className='mofo'>
    <div className='mofo-con' style={{maxWidth: '720px'}}>
      <div className='lf'>
        <h2 className='lf-h2'>Souhlas se zasíláním novinek e-mailem</h2>
        <p className='lf-pa-if'>Přihlášením k odběru novinek souhlasíte s tím, že pro tento účel bude Ivo Macák, sídlo Lípy 96, Slatinice,
          IČO 05767393, zapsaný v živnostenském rejstříku u Magistrátu města Olomouce, po dobu 10 let zpracovávat údaje
          o vaší e-mailové adrese.</p>
        <p className='lf-pa-if'>Svůj souhlas můžete kdykoli odvolat zprávou zaslanou na <a href='mailto:info@jesyka.cz' className='noa-pa'>info@jesyka.cz</a></p>
        <p className='lf-pa-if'>Informace o zpracování osobních údajů jsou k dispozici <a target='blank'
          href={process.env.PUBLIC_URL + '/doc/zou1'} className='noa-pa'>zde.</a></p>
        <div>
          <button className='lf-b' onClick={() => onClick(true)}>Ano</button>
          <button className='lf-b' onClick={() => onClick(false)}>Ne</button>
        </div>
      </div>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/UserForms/Agreement.js